<template>
  <div class="editCreate-component">
    <form @submit.prevent="save">
      <div class="form__group">
        <label class="form__label  form__label--block" for="title">{{ getTranslation('title') }}</label>
        <input v-model.trim="form.title" class="field  field--full-width"
               :class="{ 'field--error': $v.form.title.$error }" type="text" id="title">
        <div v-if="$v.form.title.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>
      <div class="form__group">
        <label class="form__label  form__label--block" for="questionCount">{{ getTranslation('questionCount') }}</label>
        <input v-model.number="form.questionCount" min="0" class="field  field--full-width"
               :class="{ 'field--error': $v.form.questionCount.$error }" type="number" id="questionCount">
        <div v-if="$v.form.questionCount.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>
      <div class="checkbox-group  form__group">
        <label class="checkbox">
          <input class="checkbox__input" v-model="form.status" type="checkbox"/>
          <span class="checkbox__indicator  checkbox__indicator--inline"/>
          <span class="checkbox__label">{{ getTranslation('active') }}?</span>
        </label>
      </div>
      <div class="resources">
        <label class="form__label  form__label--block" for="questionCount">{{ getTranslation('structureResources') }}
          <a href="javascript:void(0)" @click="addResource" :title="getTranslation('add')" class="btn  btn--square">
            <svg class="btn__icon  btn__icon--sm">
              <use xlink:href="#icon__square-add"></use>
            </svg>
          </a>
        </label>
        <div v-if="form.resources.length > 0" class="form__group">
          <table class="table table-zebra table--noborder font--size--12">
            <thead class="table__head">
            <tr class="table__row">
              <td style="width: 30%" class="table__cell table__hcell">
                {{ getTranslation('category') }}
              </td>
              <td style="width: 50%" class="table__cell table__hcell">
                {{ getTranslation('title') }}
              </td>
              <td style="width: 2%" class="table__cell table__hcell">
              </td>
            </tr>
            </thead>
            <tbody class="table__body">
            <tr v-for="(resource,index) in form.resources" v-bind:key="index" class="table__row">
              <td class="table__cell font--size--13">
                                    <span v-if="structureId">
                                        <span v-if="!resource.resource || resource.resourceType"> {{
                                            resource.resourceType
                                          }}</span>
                                         <span v-else>  {{ resource.resource.type.title }}</span>
                                    </span>
                <span v-else>{{ resource.resourceType }}</span>
              </td>
              <td class="table__cell font--size--13">
                                    <span v-if="structureId">
                                            <span v-if="(!resource.resource || resource.resourceTitle )"> {{
                                                resource.resourceTitle
                                              }}</span>
                                       <span v-else> {{ resource.resource.title }} <span
                                           v-if="resource.resource.type.id === RESOURCE_NRK_ID">({{
                                           resource.resource.resourceTitle
                                         }})</span> </span>
                                    </span>
                <span v-else>   {{ resource.resourceTitle }}</span>
              </td>
              <td class="table__cell d-flex">
                <a :title="getTranslation('delete')" @click="deleteResource(index)" class="btn  btn--white  btn--square"
                   href="javascript:void(0)">
                  <svg class="btn__icon btn__icon--sm  btn__icon--danger">
                    <use xlink:href="#icon__square-cross"></use>
                  </svg>
                </a>
                <a @click="resourceEdit(index,resource.resourceTypeId)" class="btn  btn--white  btn--square"
                   href="javascript:void(0)">
                  <svg class="btn__icon btn__icon--sm">
                    <use xlink:href="#icon__edit"></use>
                  </svg>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <p class="text text--grey">{{ getTranslation('notAddedYet') }}</p>
        </div>
      </div>
      <div class="tests">
        <label class="form__label  form__label--block" for="questionCount">{{ getTranslation('structureTests') }}
          <a href="javascript:void(0)" @click="addTest" :title="getTranslation('add')" class="btn  btn--square">
            <svg class="btn__icon  btn__icon--sm">
              <use xlink:href="#icon__square-add"></use>
            </svg>
          </a>
        </label>
        <div v-if="form.tests.length > 0" class="form__group">
          <table class="table table-zebra table--noborder">
            <thead class="table__head">
            <tr class="table__row">
              <td style="width: 35%" class="table__cell table__hcell">
                {{ getTranslation('type') }}
              </td>
              <td style="width: 20%" class="table__cell table__hcell">
                {{ getTranslation('questionCount') }}
              </td>
              <td style="width: 20%" class="table__cell table__hcell">
                {{ getTranslation('minimalPoint') }}
              </td>
              <td style="width: 20%" class="table__cell table__hcell">
                {{ getTranslation('duration') }}
              </td>
              <td style="width: 20%" class="table__cell table__hcell">
                {{ getTranslation('isRandom') }}
              </td>
              <td style="width: 20%" class="table__cell table__hcell">
                {{ getTranslation('isAggregatePoint') }}
              </td>
              <td style="width: 5%" class="table__cell table__hcell">
              </td>
            </tr>
            </thead>
            <tbody class="table__body">
            <tr v-for="(test,index) in form.tests" v-bind:key="index" class="table__row">
              <td class="table__cell">
                                    <span v-if="structureId">
                                        <span v-if="test.title">{{ test.title }}</span>
                                        <span v-else>{{ test.testType.titleRu }}</span>
                                    </span>
                <span v-else>{{ test.title }}</span>
              </td>
              <td class="table__cell"
                  :class="{'bg-danger text-white text--bold':(test.questionCount > test.typeQuestionCount) && test.testTypeId < 7}">
                {{ test.questionCount }}
              </td>
              <td class="table__cell">
                {{ test.minimalPoint }}%
              </td>
              <td class="table__cell">
                {{ test.duration }}
              </td>
              <td class="table__cell">
                <span v-if="test.randomize">{{ getTranslation('yes') }}</span>
                <span v-else>{{ getTranslation('no') }}</span>
              </td>
              <td class="table__cell">
                <span v-if="test.aggregatePoint">{{ getTranslation('yes') }}</span>
                <span v-else>{{ getTranslation('no') }}</span>
              </td>
              <td class="table__cell d-flex">
                <a :title="getTranslation('delete')" @click="deleteTest(index)" class="btn  btn--white  btn--square"
                   href="javascript:void(0)">
                  <svg class="btn__icon btn__icon--sm  btn__icon--danger">
                    <use xlink:href="#icon__square-cross"></use>
                  </svg>
                </a>
                <a class="btn  btn--white  btn--square" @click="testEdit(index)" href="javascript:void(0)">
                  <svg class="btn__icon btn__icon--sm">
                    <use xlink:href="#icon__edit"></use>
                  </svg>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <p class="text text--grey">{{ getTranslation('notAddedYet') }}</p>
        </div>
      </div>
      <div class="form__group">
        <button type="submit" class="btn btn--main">{{ getTranslation('save') }}</button>
        <router-link :to="{ name: 'api.testing.structure.getList' }" class="btn btn--main-outline">
          {{ getTranslation('cancel') }}
        </router-link>
      </div>
    </form>
    <!--  resource modal  -->
    <modal
        v-model="isResource"
        :modal-title="editResource === true ? getTranslation('edit'):getTranslation('add')"
        :ok-button-label="getTranslation('save')"
        :cancel-button-label="getTranslation('cancel')"
        @ok-button-click="saveAdding('resource')"
        @cancelButtonClick="editResource === true ? reset('resource','edit'):reset('resource','save')"
    >
      <span class="text-danger">* {{ getTranslation('required') }}</span>

      <div v-if="loadSelects" class="form__group">
        <label class="form__label  form__label--block">{{ getTranslation('resourceType') }} <span
            class="required">*</span></label>
        <v-select
            v-model="resourceType"
            :options="formOptions.resourceTypes"
            :reduce="option=>option.id"
            label="title"
            :class="{'field--error': $v.resourceType.$error}"
            :placeholder="getTranslation('selectFromList')"
        />
        <div v-if="$v.resourceType.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
      </div>
      <div v-if="resourceType === RESOURCE_LOCAL_POSITIONS_ID" class="form__group">
        <LocalStateSelect v-model="stateId" :edit-state-id="this.stateId"/>

        <div v-if="showPositions" class="form__group">
          <label class="form__label  form__label--block">{{ getTranslation('resource') }} <span
              class="required">*</span></label>
          <v-select
              v-model="resource"
              :options="resources"
              label="positionName"
              :placeholder="getTranslation('selectFromList')"
              :class="{'field--error': $v.resource.id.$error}"
          />
          <div v-if="$v.resource.id.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
      </div>
      <div v-if="resourceType === RESOURCE_EKYZMAT_ID" class="form__group">

        <StateSelect
            ref="stateSelect"
            :initialValue='[null, hrm.departmentId]'
            :department-id.sync="hrm.departmentId"
            :required="true"
        />
        <div v-if="showPositions && formOptions.positions.length > 0" class="form__group">
          <label class="form__label  form__label--block">{{ getTranslation('position') }}<span class="required">*</span></label>
          <v-select
              v-if="structureId"
              v-model="resource.id"
              :reduce="option=>option.id"
              :placeholder="getTranslation('selectFromList')"
              label="positionName"
              :options="formOptions.positions"
              :class="{'field--error': $v.resource.id.$error}"
          />
          <v-select
              v-if="!structureId"
              v-model="resource"
              :placeholder="getTranslation('selectFromList')"
              label="positionName"
              :options="formOptions.positions"
              :class="{'field--error': $v.resource.id.$error}"
          />
          <div v-if="$v.resource.id.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
      </div>
      <div
          v-if="resourceType === RESOURCE_CATEGORIES_ID || resourceType === RESOURCE_NRK_ID || resourceType === RESOURCE_REGISTER_POST_ID || resourceType ===RESOURCE_MRK_ID"
          class="form__group">

        <div class="form__group">
          <label class="form__label  form__label--block">{{ getTranslation('resource') }}<span class="required">*</span></label>
          <v-select
              v-model="resource"
              :placeholder="getTranslation('selectFromList')"
              label="title"
              :options="resources"
              :class="{'field--error': $v.resource.id.$error}"
          />
          <div v-if="$v.resource.id.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
      </div>
    </modal>
    <!--  test modal  -->
    <modal
        v-model="isTest"
        :modal-title="editTest === true ? getTranslation('edit'):getTranslation('add')"
        :ok-button-label="getTranslation('save')"
        :cancel-button-label="getTranslation('cancel')"
        :alert-class="'min-width-500'"
        @ok-button-click="saveAdding('test')"
        @cancelButtonClick="editTest === true ? resetTest('edit'):resetTest()"
    >

      <div class="col-md-12">
        <span class="text-danger">* {{ getTranslation('required') }}</span>

        <div v-if="loadSelects" class="form__group">
          <label class="form__label  form__label--block">{{ getTranslation('type') }} <span
              class="required">*</span></label>
          <v-select
              v-if="!editTest"
              v-model="testType"
              :options="formHelper.testTypes"
              label="title"
              class="field--full-width"
              :class="{'field--error': $v.test.testTypeId.$error}"
          />
          <v-select
              v-if="editTest"
              v-model="testType"
              :options="formOptions.testingTypes"
              label="title"
              :disabled="true"
              :class="{'field--error': $v.test.testTypeId.$error}"
          />
          <div v-if="$v.test.testTypeId.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
        <div v-if="!editTest && formHelper.testTypes.length < 1" class="form__group">
                <span class="text--danger">
                    {{ getTranslation('allTestTypesAdded') }}
                </span>
        </div>
        <div v-if="editTest || formHelper.testTypes.length > 0">
          <div class="form__group">
            <label class="form__label  form__label--block" for="qCount">{{ getTranslation('questionCount') }} <span
                class="required">*</span> </label>
            <input v-model.number="test.questionCount" class="field  field--full-width"
                   :class="{'field--error': $v.test.questionCount.$error}" type="number" id="qCount">
            <div v-if="$v.test.questionCount.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
          </div>
          <div class="form__group">
            <label class="form__label  form__label--block" for="duration">{{ getTranslation('duration') }} <span
                class="required">*</span> </label>
            <input v-model.number="test.duration" min="0" class="field  field--full-width"
                   :class="{'field--error': $v.test.duration.$error}" type="number" id="duration">
            <div v-if="$v.test.duration.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
          </div>
          <div class="form__group">
            <label class="form__label  form__label--block" for="minPoint">{{ getTranslation('minimalPoint') }} <span
                class="required">*</span> </label>
            <input v-model.number="test.minimalPoint" min="0" class="field  field--full-width"
                   :class="{'field--error': $v.test.minimalPoint.$error}" type="number" id="minPoint">
            <div class="form__descr">{{ getTranslation('minimalPointDescription') }}</div>
            <div v-if="$v.test.minimalPoint.$error" class="form__error">{{ getTranslation('requiredField') }}</div>
          </div>
          <div class="form__group">
            <label class="checkbox  checkbox--inline">
              <input  class="checkbox__input" type="checkbox" v-model="test.aggregatePoint">
              <span class="checkbox__indicator  checkbox__indicator--inline"></span>
              <span class="checkbox__label">{{ getTranslation('isAggregatepoint') }}?</span>
            </label>
            <div class="form__descr">{{ getTranslation('aggregatePointDescription') }}</div>
          </div>

          <div class="form__group">
            <label class="checkbox  checkbox--inline">
              <input :disabled="randomDisabled" class="checkbox__input" type="checkbox" v-model="test.randomize">
              <span class="checkbox__indicator  checkbox__indicator--inline"></span>
              <span class="checkbox__label">{{ getTranslation('isRandom') }}?</span>
            </label>
            <div class="form__descr">{{ getTranslation('randomizeDescription') }}</div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import required from "vuelidate/lib/validators/required";
import structureMixin from "@/views/admin/testingStructure/mixins/structure";
import StateSelect from "@/components/shared/StateSelect";
import hrmMethods from "@/views/admin/hrm/methods";
import LocalStateSelect from "@/components/shared/LocalStateSelect";
import test from "../../../candidate/testing/mixins/test";

const RESOURCE_CATEGORIES_ID = 4;
const RESOURCE_EKYZMAT_ID = 1;
const RESOURCE_LOCAL_POSITIONS_ID = 2;
const RESOURCE_NRK_ID = 3;

export default {
  name: "EditCreateComponent",
  components: {LocalStateSelect, StateSelect},
  mixins: [structureMixin],
  data() {
    return {

      NRK_TEST_TYPE_ID: 8,
      STATS_TEST_TYPE_ID: 7,
      ATTESTATION_TEST_TYPE_ID: 9,
      RRK_TEST_TYPE_ID: 10,
      MRK_TEST_TYPE_ID: 11,

      stateId: '',
      testType: {},

      selectedResources: [],

      loadSelects: false,
      isResource: false,
      isTest: false,
      editResource: false,
      editTest: false,
      addingIndex: 'reset',
      oldValue: {},
      showPositions: false,
      randomDisabled: false,
      form: {
        title: '',
        status: true,
        questionCount: '',
        tests: [],
        resources: [],
      },
      resourceForm: {
        resourceStateName: '',
        resourceStateId: '',
        resourceId: '',
        resourceTypeId: '',
        resourceType: '',
        resourceTitle: '',
      },

    }
  },
  props: {
    id: {
      required: false,
    }
  },
  computed: {
    postGroupId() {
      if (this.resource && this.resource.jobPost)
        return this.resource.jobPost.postGroupId;

      return false;
    },
  },
  watch: {
    testType(val) {
      if (val)
        this.test.randomize = val.ANSWER_ORDERING;
      else
        this.test.randomize = '';
    },
    postGroupId(val) {
      if (val === 1)
        this.fetchFormOptions(false, null, this.STATS_TEST_TYPE_ID);
    },
    resourceType(val) {
      this.resources = [];
      if (val && val !== this.RESOURCE_LOCAL_POSITIONS_ID) {

        this.fetchStructureResourceOptions({typeId: val}, val);

        let testTypeId = null;

        if (val === this.RESOURCE_NRK_ID) {
          testTypeId = this.NRK_TEST_TYPE_ID;
        } else if (val === this.RESOURCE_REGISTER_POST_ID)
          testTypeId = [this.ATTESTATION_TEST_TYPE_ID, this.RRK_TEST_TYPE_ID];
        else if (val === this.RESOURCE_MRK_ID)
          testTypeId = this.MRK_TEST_TYPE_ID;

        this.fetchFormOptions(false, null, testTypeId);
      }
    },
    stateId(val) {
      this.resources = [];
      if (val)
        this.fetchStructureResourceOptions({typeId: this.resourceType, stateId: val}).then(() => {
          this.showPositions = true;
        })

    },
    'hrm.departmentId'(id) {
      if (id) hrmMethods.fetchPositions(id).then(positions => {
        this.formOptions.positions = positions;
        this.showPositions = true;
      });
    }
  },
  updated() {
    this.setHeadings({
      title: this.structureId ? this.getTranslation('editingTestStructure') : this.getTranslation('addingTestStructure'),
      breadcrumbs: [
        {
          label: this.getTranslation('testingStructure'),
          route: {name: 'api.testing.structure.getList'}
        },
        {
          label: this.structureId ? this.getTranslation('editingTestStructure') : this.getTranslation('addingTestStructure'),
        }
      ],
      toBack: {
        label: this.getTranslation('backToTestStructureList'),
        route: {name: 'api.testing.structure.getList'}
      }
    });
  },
  created() {
    this.fetchFormOptions(true).then(() => {
      this.loadSelects = true;
    });
    if (this.structureId) {
      this.fetchStructure();
    }
  },
  methods: {
    fetchStructure() {
      return this.axios.get(this.$config.urls.structure.fetchTestingStructure.url.replace(':id', this.structureId))
          .then(response => {
            this.form.status = response.data.data.status;
            this.form.title = response.data.data.title;
            this.form.questionCount = response.data.data.questionCount;
            this.form.tests = response.data.data.tests;
            this.form.resources = response.data.data.resources.map(item => {
              item.resourceId = item.resource.resourceId;
              item.resourceTypeId = item.resource.type.id;

              return item;
            });
          }).catch(() => {
          });
    },

    addTest() {

      this.filterTestTypes();
      this.isTest = true;
      this.randomDisabled = true;
      this.isResource = false;
      this.resetTest();
    },

    filterTestTypes(typeId = null) {

      if (!typeId) {
        let arr = [...this.form.tests];
        this.formHelper.testTypes = [];

        for (let item of this.formOptions.testingTypes) {
          let lengthArr = arr.filter(type => item.id === type.testTypeId).length;
          if (lengthArr < 1) {
            this.formHelper.testTypes.push(item);
          }
        }
        return true;
      } else
        this.formHelper.testTypes = this.formHelper.testTypes.filter(item => {
          return item.id !== typeId;
        })

    },

    addResource() {
      this.isResource = true;
      this.isTest = false;
      this.reset(null)
    },

    deleteResource(index) {
      if (this.form.resources.length > index)
        this.form.resources.splice(index, 1);

      if (this.selectedResources.length > index)
        this.selectedResources.splice(index, 1);
    },

    deleteTest(index) {
      if (this.form.tests.length > index)
        this.form.tests.splice(index, 1);
    },

    testEdit(index) {

      this.test = {...this.form.tests[index]};

      if (this.structureId) {
        let test = this.form.tests[index];
        this.test.randomize = test.testType.ANSWER_ORDERING;

        this.randomDisabled = true;

        this.testType.title = test.testType.title;

        this.testType.id = test.testTypeId;

        this.oldValue = {...this.form.tests[index]};

      } else {

        this.testType = this.form.tests[index].testType;

        this.randomDisabled = true;
        this.oldValue.testTypeId = this.form.tests[index].testTypeId;
        this.oldValue.title = this.form.tests[index].title;
        this.oldValue.questionCount = this.form.tests[index].questionCount;
        this.oldValue.duration = this.form.tests[index].duration;
        this.oldValue.minimalPoint = this.form.tests[index].minimalPoint;
        this.oldValue.aggretagePoint = this.form.tests[index].aggretagePoint;
      }
      this.addingIndex = index;
      this.editTest = true;
      this.isTest = true;

    },

    resourceEdit(index, typeId) {
      this.resource = {
        id: ''
      };

      if (this.structureId) {
        let resourceTypeId = this.form.resources[index].resource.type.id;
        this.oldValue = {...this.form.resources[index].resource};
        this.resourceType = resourceTypeId;

        if (typeId === RESOURCE_LOCAL_POSITIONS_ID) {
          this.stateId = this.form.resources[index].resource.stateId;
          this.resource = this.form.resources[index].resource;
        } else if (typeId === RESOURCE_EKYZMAT_ID) {
          this.hrm.departmentId = this.form.resources[index].resource.department.resourceId;
          this.resource.id = this.form.resources[index].resource.resourceId;
        } else if (typeId === RESOURCE_CATEGORIES_ID || typeId === RESOURCE_NRK_ID)
          this.resource = this.form.resources[index].resource;

      } else {
        this.oldValue = {...this.form.resources[index]};
        this.resourceType = typeId;
        if (typeId === RESOURCE_LOCAL_POSITIONS_ID)
          this.stateId = this.selectedResources[index].stateId;
        this.resource = {...this.selectedResources[index]};

        if (RESOURCE_EKYZMAT_ID === typeId)
          this.hrm.departmentId = this.resource.department.id;
      }

      this.isResource = true;
      this.editResource = true;
      this.addingIndex = index;
      this.showPositions = true;


    },

    saveAdding(type = 'resource') {
      switch (type) {
        case "resource":
          this.pushResource(type);
          break;

        case "test":
          this.validateTest();
          break;
      }
    },

    validateTest() {

      this.test.testTypeId = this.testType.id;
      this.test.title = this.testType.title;
      this.test.typeQuestionCount = this.testType.questionCount;
      this.test.testType = this.testType;

      this.$v.test.$touch();

      if (this.$v.test.$invalid)
        return this.snotifyError('wrongFormMsg');

      if (this.editTest && this.addingIndex !== 'reset') {
        this.form.tests[this.addingIndex] = {...this.test};

        this.editTest = false;

      } else {

        this.filterTestTypes(this.test.testTypeId);

        this.form.tests.push(this.test);

        this.resetTest('save');
      }

      this.cancelAdding();

    },
    pushResource(type) {
      this.$v.resourceType.$touch();
      this.$v.resource.$touch();

      if (this.$v.resourceType.$invalid || this.$v.resource.$invalid)
        return this.snotifyError('wrongFormMsg');

      if (!this.fillResourceForm(this.resourceType, this.resource))
        return this.snotifyError('wrongFormMsg');


      if (this.editResource && this.addingIndex !== 'reset') {

        this.form.resources[this.addingIndex] = this.resourceForm;
        this.selectedResources[this.addingIndex] = this.resource;
      } else {
        let found = false;
        for (let item of this.form.resources) {
          if (this.resourceForm.resourceId === item.resourceId &&
              this.resourceForm.resourceTypeId === item.resourceTypeId)
            found = true;
        }
        if (!found)
          this.form.resources.push(this.resourceForm);
        this.selectedResources.push(this.resource);
      }

      this.reset(type, 'save');
      this.cancelAdding();

    },

    fillResourceForm(typeId, resource) {

      switch (typeId) {
        case RESOURCE_LOCAL_POSITIONS_ID:
          this.resourceForm = {
            resourceId: resource.id,
            resourceStateId: resource.stateId,
            resourceTypeId: typeId,
            resourceType: resource.type.title,
            resourceStateName: resource.state.name,
            resourceTitle: resource.positionName,
          };
          if (this.structureId)
            this.resourceForm.resource = {...resource};

          return true;

        case RESOURCE_EKYZMAT_ID:
          if (!this.$refs.stateSelect.checkValidity())
            return this.snotifyError('wrongFormMsg');

          this.resourceForm = {
            resourceId: resource.id,
            resourceTypeId: typeId,
            resourceType: this.RESOURCE_TYPES[typeId],
            resourceTitle: resource.positionName
          };

          if (this.resource.jobPost && this.resource.jobPost.postGroupId)
            this.resourceForm.postGroupId = this.resource.jobPost.postGroupId;

          let positionArr = this.formOptions.positions.filter(item => {
            return item.id === resource.id;
          });

          if (positionArr.length === 1) {
            let position = positionArr[0];

            this.resourceForm.resourceTitle = position.positionName;

            let hrmResource = {};

            let dep = {
              resourceId: position.department.id,
            };

            hrmResource.resourceId = position.id;
            hrmResource.department = dep;
            hrmResource.type = {
              id: typeId
            };

            if (this.structureId)
              this.resourceForm.resource = hrmResource;
          }

          return true;

        case RESOURCE_CATEGORIES_ID:
          this.resourceForm = {
            resourceId: resource.id,
            resourceTypeId: typeId,
            resourceType: resource.type.title,
            resourceTitle: resource.title
          };

          if (this.structureId)
            this.resourceForm.resource = {...resource};

          return true;

        case RESOURCE_NRK_ID:
          this.resourceForm = {
            resourceId: resource.resourceId,
            resourceTypeId: typeId,
            resourceType: resource.type.title,
            resourceTitle: resource.title,
            id: resource.id
          };

          if (this.structureId)
            this.resourceForm.resource = {...resource};

          return true;

        case this.RESOURCE_REGISTER_POST_ID:
        case this.RESOURCE_MRK_ID:
          this.resourceForm = {
            resourceId: resource.resourceId,
            resourceTypeId: typeId,
            resourceType: resource.type.title,
            resourceTitle: resource.title,
            postScope: resource.postScope,
            id: resource.id
          };

          if (this.structureId)
            this.resourceForm.resource = {...resource};

          return true;

        default:
          return false;

      }
    },

    save() {
      this.$v.form.$touch();

      if (this.$v.form.$invalid) {

        if (this.$v.form.tests.$error)
          return this.snotifyError('addTestError', null, 4000);

        if (this.$v.form.resources.$error)
          return this.snotifyError('addResourceError', null, 4000);

        this.snotifyError('wrongFormMsg');

      } else {
        if (this.structureId) {

          this.axios.put(this.$config.urls.structure.fetchTestingStructure.url.replace(':id', this.structureId), this.form)

              .then(response => {

                this.snotifySuccess('saveSuccessMsg');
                this.$router.push({name: 'api.testing.structure.get', params: {id: response.data.data.id}})
              }).catch(() => {
          });
        } else {
          this.axios.post(this.$config.urls.structure.fetchTestingStructures.url, this.form)

              .then(response => {

                this.snotifySuccess('saveSuccessMsg');
                this.$router.push({name: 'api.testing.structure.get', params: {id: response.data.data.id}})

              }).catch(() => {
          });
        }
      }
    },
    cancelAdding() {
      this.isTest = false;
      this.isResource = false;
      this.showPositions = false;

      this.$v.$reset();
    },
    resetTest(action = 'save') {
      this.$v.$reset();
      this.test = {
        title: '',
        testTypeId: '',
        questionCount: '',
        typeQuestionCount: '',
        minimalPoint: '',
        aggregatePoint: '',
        duration: '',
      };
      this.testType = {};
      this.editTest = false;

      if (action === 'edit' && this.addingIndex !== 'reset') {
        this.form.tests[this.addingIndex] = this.oldValue;
        this.editTest = false;
        return this.addingIndex = 'reset';
      }
    },
    reset(type, action = 'save') {
      this.resourceType = '';
      this.resource = {};
      this.resourceForm = {};
      this.$v.$reset();
      this.editResource = false;
      this.showPositions = false;
      this.stateId = '';
      this.hrm.departmentId = '';

      if (action === 'edit' && this.addingIndex !== 'reset') {
        this.form.resources[this.addingIndex] = this.oldValue;
        this.addingIndex = 'reset';
      } else
        this.oldValue = {};
    },
  },
  validations: {
    form: {
      title: {
        required
      },
      status: {
        required
      },
      questionCount: {
        required
      },
      resources: {
        required
      },
      tests: {
        required
      },
    },
    resource: {
      id: {
        required
      },
    },
    resourceType: {
      required
    },
    test: {
      testTypeId: {
        required
      },
      questionCount: {
        required
      },
      duration: {
        required
      },
      minimalPoint: {
        required
      }
    }
  }
}
</script>

<style scoped>
.font--size--13 {
  font-size: 13px !important;
}
</style>
